import { z } from 'zod'

import { okamiHttpGateway } from '@/lib/axios'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { toast } from 'sonner'

const createSessionInputSchema = z.object({
  email: z.string().email(),
  password: z.string().min(8),
})

export type CreateSessionInput = z.infer<typeof createSessionInputSchema>

export type CreateSessionOutput = {
  refreshToken: string
  token: string
}

export async function createSession(payload: CreateSessionInput) {
  const parsed = createSessionInputSchema.parse(payload)

  await okamiHttpGateway.post<CreateSessionOutput>('/auth/v2/login', parsed)
}

export function useCreateSession() {
  return useMutation({
    mutationFn: createSession,

    onSuccess() {
      toast.success('Login feito com sucesso')
    },

    onError(err) {
      if (err instanceof AxiosError) {
        if ([400, 401].includes(err.response?.status || 0)) {
          toast.error('Usuário ou senha inválidos!')
        }
      } else {
        toast.error('Opa, algo deu errado! Tente novamente mais tarde.')
      }
    },
  })
}
